module.exports = __webpack_public_path__ + "assets/img/video-banner-detail.927a4f87.png";